import { RESOURCE_ICONS, RESOURCE_NAMES, RESOURCE_TEXT, type ResourceKey } from '../../icons';
import { formatNumber } from '../../labels';

/** Amount of one resource, with its storage bar (amber near the cap, red at it) and rate. */
export function ResourceChip({
  resource,
  amount,
  cap,
  ratePerHour,
}: {
  resource: ResourceKey;
  amount: number | undefined;
  cap?: number;
  ratePerHour?: number;
}) {
  const Icon = RESOURCE_ICONS[resource];
  const share = cap && amount !== undefined ? Math.min(1, amount / cap) : undefined;
  const barColour =
    share === undefined ? '' : share >= 1 ? 'bg-danger' : share >= 0.9 ? 'bg-accent' : 'bg-current';
  return (
    <div
      title={RESOURCE_NAMES[resource]}
      className={`min-w-0 flex-1 border-l-2 border-current bg-panel px-2 py-1.5 ${RESOURCE_TEXT[resource]}`}
    >
      <div className="flex items-center gap-1 font-display text-[10px] font-bold uppercase tracking-[0.16em]">
        <Icon className="size-3.5 shrink-0" aria-hidden />
        <span className="truncate">{RESOURCE_NAMES[resource]}</span>
      </div>
      <div className="font-mono text-sm tabular-nums text-text">
        {amount === undefined ? '—' : formatNumber(amount)}
        {cap !== undefined ? <span className="text-faint"> / {formatNumber(cap)}</span> : null}
      </div>
      {share !== undefined ? (
        <div className="mt-1 h-0.5 bg-line">
          <div className={`h-0.5 ${barColour}`} style={{ width: `${share * 100}%` }} />
        </div>
      ) : null}
      {/* Its own line: next to the name it squeezed "Supplies" to "SUPPL…" on phones. */}
      {ratePerHour !== undefined ? (
        <div className="mt-0.5 font-mono text-[10px] tabular-nums text-muted">
          +{formatNumber(ratePerHour)}/h
        </div>
      ) : null}
    </div>
  );
}
